interface AppSettings {
  getUrl: () => string;
  BASE_URL: () => string;
  AUTH_URL: () => string;
}
const AppSettings: AppSettings = {
  getUrl: () => {
    const currentURL = window.location.href;
    //const currentURL = 'https://devrct.e-medicall.com/#/login';
    // const currentURL = 'https://e-medicall.com/#/login';
    const Locationsurls = currentURL.match(/(https?:\/\/[^\/]*\.com)/) as any;
    // const Locationsurls = currentURL.match(/http?:\/\/[^\/]+/) as any;
    window.sessionStorage.setItem('Locationsurls', Locationsurls[0])
    const localPath = currentURL.includes('localhost');
    console.log('localPath', localPath);
    const splitPath = currentURL.split('://')[1].split('.');
    const firstPart = splitPath[0];
    const threeChar = firstPart.slice(0, 3)
    const isDevReactPath = threeChar.includes('dev');
    console.log("firstPart", firstPart)
    const isValReactPath = threeChar.includes('val');
    const isReactPath = currentURL.includes('https://e-medicall.com');
    console.log("threeChar", threeChar)
    console.log("isDevReactPath", isDevReactPath)

    // const country = extractCountryFromUrl(currentURL);
    // const countryPath = country === 'india' ? 'india' : 'america';
    // Define base URLs for different environments
    let baseDomain;
    if (isDevReactPath) {
      // const countryPath = 'india';
      baseDomain = `https://devapi.e-medicall.com/medi/api`;
    } else if (isValReactPath) {
      baseDomain = `https://valapi.e-medicall.com/medi/api`;
      // } else if (isReactPath) {
      //   baseDomain = `https://api.e-medicall.com/medi/api`;
    } else {
      // baseDomain = "http://192.168.1.197/Finalprod/API/emedicall/medi/api"
      baseDomain = `http://api.e-medicall.com/medi/api`;
    }
    const fullUrl = `${baseDomain}`;
    window.sessionStorage.setItem("baseDomain", baseDomain as any);
    let apiRoot;
    if (isDevReactPath) {
      apiRoot = `https://devapi.e-medicall.com`;
    } else if (isValReactPath) {
      apiRoot = `https://valapi.e-medicall.com`;
      // } else if (isReactPath) {
      //   apiRoot = `http://api.e-medicall.com`;
    }
    else {
      // apiRoot = `https://192.168.1.197/Finalprod/API/emedicall/`;
      baseDomain = `http://api.e-medicall.com`;
    }
    window.sessionStorage.setItem("apiRoot", apiRoot as any);

    return fullUrl;
  },
  BASE_URL: () => {
    return AppSettings.getUrl();
  },
  AUTH_URL: () => {

    return 'https://jwtauth.jwtechinc.com/';
  }
};
export const isDevReactPath = (url: string): boolean => {
  return url.includes('devrct');
};

export const isValReactPath = (url: string): boolean => {
  return url.includes('valrct');
};

export const isReactPath = (url: string): boolean => {
  return url.includes('https://e-medicall.com');
};



export default AppSettings;